import { useFavouriteDefinitions, useLoadFavouriteDefinitionEffect } from 'app/area/favourite/hooks';
import { FiltersContainer } from 'app/area/filters/filters';
import * as React from 'react';

interface BowtieFiltersFavouriteProps {
  favouriteId: number;
  locale: string;
}

export function BowtieFiltersFavourite({
  favouriteId, locale
}: BowtieFiltersFavouriteProps) {
  
  const {
    definition,
    updateDefinition
  } = useFavouriteDefinitions();

  useLoadFavouriteDefinitionEffect(favouriteId, true);

  return (
    <FiltersContainer
      definition={definition}
      updateDefinition={updateDefinition}
      locale={locale} />
  );
}
